
import { useState } from 'react';
import { useAuth } from '../lib/auth';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Input } from "@/components/ui/input"
import { Button } from "@/components/ui/button"

export const AuthForm = () => {
  const { login, signup } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [isSignup, setIsSignup] = useState(false);
  const [referral, setReferral] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    
    if (isSignup) {
      signup(username, email, password)
        .then(() => {
          toast.success('Signup successful!');
          // Do not navigate here. Let Auth.tsx handle navigation via isAuthenticated state.
        })
        .catch((error: Error) => {
          setError(error.message);
          toast.error(error.message);
        })
        .finally(() => setIsLoading(false));
    } else {
      login(email, password)
        .then(() => {
          toast.success('Login successful!');
          // Do not navigate here. Let Auth.tsx handle navigation via isAuthenticated state.
        })
        .catch((error: Error) => {
          setError(error.message);
          toast.error(error.message);
        })
        .finally(() => setIsLoading(false));
    }
    // When handling signup, you can track or display referral code here
  };
  
  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {isSignup && (
        <div>
          <label htmlFor="username" className="block text-xs mb-1 font-semibold text-bauhaus-green/90">
            Username
          </label>
          <Input
            id="username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full px-3 py-2 border rounded border-bauhaus-green font-medium"
            placeholder="Your Username"
            required
          />
        </div>
      )}
      
      <div>
        <label htmlFor="email" className="block text-xs mb-1 font-semibold text-bauhaus-green/90">
          Email
        </label>
        <Input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full px-3 py-2 border rounded border-bauhaus-green font-medium"
          placeholder="you@example.com"
          required
        />
      </div>
      
      <div>
        <label htmlFor="password" className="block text-xs mb-1 font-semibold text-bauhaus-green/90">
          Password
        </label>
        <Input
          id="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full px-3 py-2 border rounded border-bauhaus-green font-medium"
          placeholder="Password"
          required
        />
      </div>
      {isSignup && (
        <div className="mb-3">
          <label htmlFor="referral" className="block text-xs mb-1 font-semibold text-bauhaus-green/90">
            Referral Code (optional)
          </label>
          <input
            id="referral"
            type="text"
            value={referral}
            onChange={(e) => setReferral(e.target.value)}
            className="w-full px-3 py-2 border rounded border-bauhaus-green font-medium"
            placeholder="ABC123"
          />
        </div>
      )}
      
      {error && <p className="text-red-500 text-sm font-medium">{error}</p>}
      
      <Button type="submit" disabled={isLoading} className="w-full bg-bauhaus-green text-white font-semibold py-3 rounded-md shadow flex justify-center items-center hover:bg-bauhaus-darkgreen focus-visible:outline focus-visible:ring-2 focus-visible:ring-bauhaus-green transition-all aria-disabled:opacity-60">
        {isLoading ? (
          <span className="flex gap-2 items-center">
            <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-20" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
            </svg>
            Loading
          </span>
        ) : (
          <>
            {isSignup ? 'Sign Up' : 'Log In'}
          </>
        )}
      </Button>
      
      <button type="button" onClick={() => setIsSignup(!isSignup)} className="w-full text-center text-sm text-bauhaus-green font-semibold hover:underline focus-visible:outline focus-visible:ring-2 focus-visible:ring-bauhaus-green transition">
        {isSignup ? 'Already have an account? Log In' : 'Need an account? Sign Up'}
      </button>
    </form>
  );
};

export default AuthForm;

